module.exports = __webpack_public_path__ + "static/media/schedule_black.20604bff.svg";